const DocumentDownload = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 26" fill="none">
      <path
        d="M9.75 11.9165V18.4165L11.9167 16.2498"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.7487 18.4167L7.58203 16.25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.8346 10.8332V16.2498C23.8346 21.6665 21.668 23.8332 16.2513 23.8332H9.7513C4.33464 23.8332 2.16797 21.6665 2.16797 16.2498V9.74984C2.16797 4.33317 4.33464 2.1665 9.7513 2.1665H15.168"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.8346 10.8332H19.5013C16.2513 10.8332 15.168 9.74984 15.168 6.49984V2.1665L23.8346 10.8332Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default DocumentDownload;
